import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorPopup from './ErrorPopup';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            showPopup: false,
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
            showPopup: true,
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo,
            showPopup: true,
        });
    }

    handleDismissError = () => {
        this.setState({ showPopup: false });
    };

    handleResetError = () => {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null,
            showPopup: false,
        });
    };

    render() {
        const { hasError, error, errorInfo, showPopup } = this.state;
        const { children, fallback } = this.props;

        if (hasError) {
            return (
                <>
                    {fallback || <> </>
                    }
                    {showPopup && error && (
                        <ErrorPopup
                            error={error}
                            errorInfo={errorInfo}
                            onDismiss={this.handleDismissError}
                            onReset={this.handleResetError}
                        />
                    )}
                </>
            );
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};
